// DATORACODE - Sticky Add-to-Cart Button für Mobile PDP
// Mirrors the currently actionable underlying button:
//   1. Klaviyo BIS ("Notify me when back in stock") if injected and visible
//   2. Shopify ATC (.product-form__submit) if visible and enabled
//   3. otherwise hide the sticky entirely (no disabled state shown)

var stickyAtc = document.getElementById('sticky-atc');
var formButtons = document.querySelector('.product-form__buttons');

if (stickyAtc && formButtons) {
  var stickyIsLoading = false;

  // Variant-Info-Block (nur in A/B-Variante B vorhanden). Fallback-Thumbnail =
  // initial via Liquid gerendertes Produkt-Bild.
  var variantInfo = document.querySelector('.sticky-atc__variant-info');
  var variantThumb = variantInfo && variantInfo.querySelector('.sticky-atc__variant-thumb');
  var variantColor = variantInfo && variantInfo.querySelector('.sticky-atc__variant-color');
  var variantSize = variantInfo && variantInfo.querySelector('.sticky-atc__variant-size');
  var fallbackThumbSrc = variantThumb ? variantThumb.getAttribute('src') : '';

  function setVariantSpan(span, value) {
    if (!span) return;
    span.textContent = value || '';
    span.hidden = !value;
  }

  function syncVariantInfo(variant) {
    if (!variantInfo || !variant) return;
    if (variantThumb) {
      // Variant-Master-URL auf Thumbnail-Breite begrenzen; fallbackThumbSrc trägt
      // bereits width=100 aus dem Liquid-Render.
      var raw = variant.featured_image && variant.featured_image.src;
      var src = raw ? raw + (raw.indexOf('?') !== -1 ? '&' : '?') + 'width=100' : fallbackThumbSrc || '';
      variantThumb.hidden = !src;
      if (src) variantThumb.src = src;
    }
    setVariantSpan(variantColor, variant.option1);
    setVariantSpan(variantSize, variant.option2);
  }

  // offsetParent !== null reliably detects layout-removed elements
  // (display:none, display:none !important, detached, ancestor-hidden).
  function isLaidOut(el) {
    return !!el && el.offsetParent !== null;
  }

  function getActionableButton() {
    // Klaviyo BIS — onsite.js injects an <a class="klaviyo-bis-trigger"> directly
    // into .product-form__buttons (no separate container wrapper).
    var bisBtn = formButtons.querySelector('.klaviyo-bis-trigger');
    if (isLaidOut(bisBtn)) {
      return { type: 'bis', el: bisBtn };
    }

    // Mirror the underlying ATC even during in-flight submit, but ONLY when
    // the sticky initiated it (stickyIsLoading=true) — so updateSticky() can
    // sync the spinner. For native-initiated in-flight submits the sticky must
    // NOT look actionable: it would have no spinner mirror and every tap would
    // silently no-op against the aria-disabled guard in the click handler.
    var atc = formButtons.querySelector('button.product-form__submit');
    var atcIsBusy =
      atc && (atc.classList.contains('loading') || atc.getAttribute('aria-disabled') === 'true');
    if (isLaidOut(atc) && !atc.disabled && (!atcIsBusy || stickyIsLoading)) {
      return { type: 'atc', el: atc };
    }

    return null;
  }

  function clearLoadingState() {
    if (!stickyIsLoading) return;
    stickyIsLoading = false;
    stickyAtc.classList.remove('loading');
    var spinner = stickyAtc.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
    document.body.classList.remove('sticky-atc-is-loading');
  }

  function readButtonText(el) {
    var span = el.querySelector('span');
    var raw = (span ? span.textContent : el.textContent) || '';
    return raw.trim().replace(/\s+/g, ' ');
  }

  function updateSticky() {
    var action = getActionableButton();

    if (!action) {
      // Variant may have changed mid-ATC-loading; without this, the body
      // class would persist and suppress the original ATC's spinner.
      clearLoadingState();
      stickyAtc.classList.add('sticky-atc--no-action');
      stickyAtc.disabled = true;
      return;
    }

    // Switched to BIS while sticky was still in ATC-loading state — flush flags.
    if (action.type !== 'atc') {
      clearLoadingState();
    }

    stickyAtc.classList.remove('sticky-atc--no-action');
    stickyAtc.dataset.actionType = action.type;
    stickyAtc.disabled = false;

    var stickyText = stickyAtc.querySelector('.sticky-atc__text');
    if (stickyText) {
      // Variante B (A/B-Test): feste Kurz-Labels für ATC und BIS, damit der Text in der Bar nicht abgeschnitten wird.
      if (action.type === 'atc' && stickyAtc.dataset.atcShortLabel) {
        stickyText.textContent = stickyAtc.dataset.atcShortLabel;
      } else if (action.type === 'bis' && stickyAtc.dataset.bisShortLabel) {
        stickyText.textContent = stickyAtc.dataset.bisShortLabel;
      } else {
        stickyText.textContent = readButtonText(action.el);
      }
    }

    // Loading-state only applies when the user clicked the sticky for ATC.
    // BIS only opens a Klaviyo modal — no loading.
    if (action.type === 'atc' && stickyIsLoading) {
      var normalIsLoading = action.el.classList.contains('loading');
      stickyAtc.classList.toggle('loading', normalIsLoading);
      var stickySpinner = stickyAtc.querySelector('.loading__spinner');
      if (stickySpinner) stickySpinner.classList.toggle('hidden', !normalIsLoading);

      if (!normalIsLoading) {
        stickyIsLoading = false;
        document.body.classList.remove('sticky-atc-is-loading');
      }
    }
  }

  stickyAtc.addEventListener('click', function () {
    // Ignore clicks while in loading state — pointer-events: auto in CSS
    // intercepts the click here so it doesn't fall through to elements behind
    // the sticky button.
    if (stickyAtc.classList.contains('loading')) return;

    var action = getActionableButton();
    if (!action) return;

    if (action.type === 'atc') {
      // product-form.js sets aria-disabled='true' synchronously on submit;
      // skip forwarding to avoid no-op round trips through onSubmitHandler.
      if (action.el.getAttribute('aria-disabled') === 'true') return;
      stickyIsLoading = true;
      document.body.classList.add('sticky-atc-is-loading');
    }
    action.el.click();
  });

  // Show sticky once the underlying buttons wrapper has scrolled out of view.
  // Anchoring on the wrapper (not on .product-form__submit) keeps the sticky
  // working when Klaviyo hides the ATC via display:none !important in BIS mode.
  // The boundingClientRect.top < 0 guard ensures we only reveal the sticky once
  // the wrapper has scrolled past the top of the viewport — without it, the
  // sticky would also flash when the wrapper is below the fold on initial load.
  var visibilityObserver = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    stickyAtc.classList.toggle('sticky-atc--visible', scrolledPast);
  });
  visibilityObserver.observe(formButtons);

  // Catches: Klaviyo trigger injection (childList), Klaviyo toggling the
  // ATC's display:none !important, and the ATC's disabled-attribute flips
  // that product-info.js performs on variant change.
  var stateObserver = new MutationObserver(updateSticky);
  stateObserver.observe(formButtons, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'disabled', 'class', 'hidden'],
  });

  // Defensive resync on variant change in case product-info ever swaps the
  // wrapper wholesale (the in-place toggleSubmitButton path is already covered
  // by the mutation observer above).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      updateSticky();
      if (event && event.data) syncVariantInfo(event.data.variant);
    });
  }

  updateSticky();
}
